import { memo } from 'react';

import { CircleMinusIcon, CirclePlusIcon, ImagesIcon, MaximizeIcon, MinimizeIcon, XIcon } from '@air/design-icons';

import { type Shortcut, ShortcutsList } from '~/components/ShortcutsList';

const BASIC_SHORTCUTS: Shortcut[] = [
  {
    id: 'next-previous-asset',
    icon: ImagesIcon,
    label: 'Next/previous asset',
    keys: ['left', 'right'],
    separator: '/',
  },
  {
    id: 'zoom-in',
    icon: CirclePlusIcon,
    label: 'Zoom in',
    keys: ['meta+plus'],
  },
  {
    id: 'zoom-out',
    icon: CircleMinusIcon,
    label: 'Zoom out',
    keys: ['meta+minus'],
  },
  {
    id: 'zoom-to-100',
    icon: MinimizeIcon,
    label: 'Zoom to 100%',
    keys: ['meta+shift+0'],
  },
  {
    id: 'full-screen',
    icon: MaximizeIcon,
    label: 'Full screen',
    keys: ['meta+0'],
  },
  {
    id: 'close-asset',
    icon: XIcon,
    label: 'Close asset',
    keys: ['esc'],
  },
];

export const BasicShortcutsInfo = memo(() => <ShortcutsList shortcuts={BASIC_SHORTCUTS} />);

BasicShortcutsInfo.displayName = 'BasicShortcutsInfo';
